package music.jammers.client.shared.event.presentation.viewmodel

import kotlinx.datetime.LocalDateTime
import music.jammers.shared.event.domain.model.CardInfo
import music.jammers.shared.event.domain.model.EventInstrument

data class CreateEventState(
    val progress: Boolean = true,
    val title: String = "",
    val description: String = "",
    val date: LocalDateTime? = null,
    val genre: String = "",
    val spot: String = "",
    val songsCount: String = "",
    val appliesPerPerson: String = "",
    val instruments: List<EventInstrument> = emptyList(),
    val bottomNavigationOpen: Boolean = false,
    val cardInfo: CardInfo? = null,
    val error: Throwable? = null,
)